const previewContractScheme = document => {
  const signerObj = props => {
    const body = {
      nombre: props?.firstName ? props.firstName : '__________',
      segundoNombre: props?.secondName ? props.secondName : '',
      apellido: props?.lastName ? props.lastName : '__________',
      segundoApellido: props?.mLastName ? props.mLastName : '',
      rut: props?.rut ? props.rut : '__________',
      genero: props?.gender ? props.gender : '__________',
      nacionalidad: props?.nationality ? props.nationality : '__________',
      estadoCivil: props?.civilStatus ? props.civilStatus : '__________',
      profesion: props?.profession ? props.profession : '__________',
      direccion: props?.address ? props.address : '__________',
      comuna: props?.commune ? props.commune : '__________',
      telefono: `${props?.phonePrefix ?? '+56'} ${props?.phoneNumber ? props.phoneNumber.replace(/\s/g, '') : '__________'}`,
      email: props?.email ? props.email : '__________',
    };

    if (props?.hasLegalPerson) {
      body.personaJuridica = {
        eud: props?.companyCreationMethod ? props.companyCreationMethod : false,
        razon: props?.businessName ? props.businessName : '__________',
        giro: props?.giro ? props.giro : '__________',
        rut: props?.companyRol ? props.companyRol : '__________',
        direccion: props?.address ? props.address : '__________',
        comuna: props?.commune ? props.commune : '__________',
        fechaPoder: props?.dateOfconstitution ? new Date(props.dateOfconstitution).toISOString() : '__________',
      };
      if (!props?.companyCreationMethod) {
        body.personaJuridica.notarioPoder = props.constitutionNotary ?? '__________';
      }
    }

    return body;
  };

  //base data ==============================================================================================
  const data = {
    formType: 'rentContract',
    sourceUrl: document.sourceUrl,
    fecha: document.dateSign ? new Date(document.dateSign).toISOString() : '__________',
    lugar: document.citySign ?? '__________',
    arrendador: signerObj(document.lessor[0]),
    arrendatario: signerObj(document.lessee[0]),
    inmueble: {
      tipo: document.typeOfHousing ?? '__________',
      direccion: document.homeAddress ?? '__________',
      comuna: document.homeCommune ?? '__________',
    },
    arriendo: {
      fecha: document.initialLeaseDate ? new Date(document.initialLeaseDate).toISOString() : '__________',
      duracion: `${document.contractDurationNumber ?? '__________'} ${document.contractDurationRange ?? '__________'}`,
      autorenovacion: document.autoRenewal ?? false,
      montoMensual: document.monthlyRent?.toString() ?? '__________',
      tipoCambio: document.typeOfCurrency ?? '__________',
      periodoPago: document.paymentPeriod?.toString() ?? '__________',
      montoGarantia: document.guaranteeAmount?.toString() ?? '__________',
      prohibeAnimales: document.petBan ?? false,
      sancion: document.sanction ?? false,
    },
    tipoPago: document.paymentType ?? '__________',
    owner: {
      nombre: document.webpay_name ?? '__________',
      rut: document.webpay_rut ?? '__________',
      direccion: document.webpay_address ?? '__________',
      ciudad: document.webpay_city ?? '__________',
      email: document.webpay_email ?? '__________',
      telefono: document.webpay_phone ?? '__________',
    },
    cuentaPago: {
      nombre: document.holdersName ?? '__________',
      rut: document.holdersRut ?? '__________',
      email: document.notificationEmail ?? '__________',
      banco: document.bank ?? '__________',
      tipoCuenta: document.typeBankAccount ?? '__________',
      numeroCuenta: document.accountNumber ?? '__________',
    }
  };

  // extra lessee ==============================================================================================
  data.arrendatarios = document.lessee.filter((_, i) => i > 0).map(signer => { return signerObj(signer); });

  //optional codebtor ==============================================================================================
  if (document.hasCodebtor) {
    data.codeudor = signerObj(document.codebtor[0], 0);
  }

  if (document.hasCodebtor && document.codebtor[0] >= 1) {
    data.codeudores = document.codebtor.filter((_, i) => i > 0).map(signer => { return signerObj(signer); });
  };

  //optional contract data ==============================================================================================
  if (document.rentAdjustment) {
    data.arriendo.tipoReajuste = document.rentAdjustment;
    if (document.rentAdjustment === 'ipc') {
      data.arriendo.periodoReajuste = document.IPCAdjustment ?? '__________';
    }
    if (document.rentAdjustment === 'porcentaje') {
      data.arriendo.montoReajuste = document.percentAdjustment ?? '__________';
      data.arriendo.periodoReajuste = `cada ${document.readjustmentValue} ${document.readjustmentRange}` ?? '__________';
    }
  }
  if (document.finesType) {
    data.arriendo.tipoCambioMulta = document.finesType ?? '__________';
    data.arriendo.montoPenalizacion = document.finesAmount?.toString() ?? '__________';
  }
  if (document.hasParking && document.parking[0]) {
    data.inmueble.listaEstacionamiento = document.parking.map(number => Object.values(number).flat(1)[0].toString()) ?? ['__________'];
  }
  if (document.hasWarehouse && document.warehouse[0]) {
    data.inmueble.listaBodega = document.warehouse.map(number => Object.values(number).flat(1)[0].toString()) ?? ['__________'];
  }

  //payment data ==============================================================================================
  if (document.payCommonExpenses) {
    data.arriendo.gastosComunes = document.payCommonExpenses ?? '__________';
  }
  return data;
};

export default previewContractScheme;
